export default __webpack_public_path__ + "cb73b13d68440b8a70d1d145cb48fa42.png";